import { render, staticRenderFns } from "./PostFull.vue?vue&type=template&id=7973ddf4&scoped=true&"
import script from "./PostFull.vue?vue&type=script&lang=js&"
export * from "./PostFull.vue?vue&type=script&lang=js&"
import style0 from "./PostFull.vue?vue&type=style&index=0&id=7973ddf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973ddf4",
  null
  
)

export default component.exports